import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { FieldSet, Field } from 'common/components/Form';
import connectToStores from 'fluxible-addons-react/connectToStores';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';
import BookCalculatorFieldOptionStore from 'book-calculator/stores/BookCalculatorFieldOptionStore';
import { handleUpdatedAttribute } from 'book-calculator/actions/handleUpdatedAttribute';
import GallerySlider from 'common/components/GallerySlider';

class CoverFieldset extends React.Component {
    handleUpdateAttribute(key, value) {
        this.context.executeAction(handleUpdatedAttribute, {
            key: key,
            value: value,
        });
    }

    render() {
        const { coverDesign } = this.props;
        const galleryItems = this.getGalleryItems();
        const currentIndex = galleryItems.findIndex(i => i.value === coverDesign);

        return (
            <FieldSet twoColumn={false}>
                <div className="row">
                    <div className="column">
                        <Field
                            title={<FormattedMessage id="fields.cover_design_cost.label" />}
                            variations={['jumbo-title']}
                        >
                            <GallerySlider
                                selectedItemIndex={currentIndex}
                                variations={['slideshow']}
                                onChange={selectedItem => {
                                    this.handleUpdateAttribute(
                                        'cover_design_cost',
                                        selectedItem.value
                                    );
                                }}
                                items={galleryItems}
                            />
                        </Field>
                    </div>
                </div>
            </FieldSet>
        );
    }

    getGalleryItems() {
        const { coverDesignOptions } = this.props;

        return coverDesignOptions.map((item, index) => {
            const step = index + 1;
            const srcImg = require(`images/book-calculator/cover-design-${step}.png`);

            return {
                value: item.value,
                topLabel: (
                    <div className="heading heading--h5 heading--no-margin heading--root">
                        {item.name}
                    </div>
                ),
                bottomLabel: (
                    <FormattedNumber
                        value={item.value}
                        style="currency"
                        currency={'USD'}
                        minimumFractionDigits={0}
                        maximumFractionDigits={0}
                    />
                ),
                image: (
                    <img
                        width="185"
                        height="295"
                        src={`${srcImg}?auto=format&dpr=1&crop=faces&fit=crop&w=185&h=295`}
                        srcSet={`${srcImg}?auto=format&dpr=2&crop=faces&fit=crop&w=185&h=295 2x,
                            ${srcImg}?auto=format&dpr=2&crop=faces&fit=crop&w=185&h=295 3x`}
                    />
                ),
            };
        });
    }
}

CoverFieldset.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

CoverFieldset.propTypes = {
    coverDesign: PropTypes.number.isRequired,
    coverDesignOptions: PropTypes.array.isRequired,
};

export default connectToStores(CoverFieldset, [BookCalculatorAttributesStore], (context, prop) => {
    const attributes = context.getStore(BookCalculatorAttributesStore).getState();
    const options = context.getStore(BookCalculatorFieldOptionStore).getOptions();

    return {
        coverDesign: attributes['cover_design_cost'],
        coverDesignOptions: options['cover_design_cost'],
    };
});
